import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-268" data-mp="2x19v2fagicak">
      <div className="mx-auto max-w-5xl" data-id="element-269" data-mp="2wzyv6qk4tooq">
        <h2 className="text-center font-serif text-[30px] leading-tight sm:text-5xl font-extrabold text-ink" data-id="element-270" data-mp="2szoo1aklss8a">
          What’s inside: <em className="text-brand-600" data-id="element-271" data-mp="2o13icvml1gcg">the 6 premium volumes</em>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[17px] text-muted" data-id="element-272" data-mp="2j9v9c0p5zwzt">
          One volume for each stage of the case — from first look to final review.
        </p>

        <div className="mt-10 space-y-5" data-id="element-273" data-mp="2e8penxby1znn">
          {volumes.map(v => <article key={v.number} className="grid gap-5 rounded-3xl border border-brand-100 bg-cream p-6 sm:p-8 md:grid-cols-[120px_1fr] md:gap-8" data-id="element-274" data-mp="29da71n4j4zzo">
              <div className="flex items-center gap-4 md:flex-col md:items-start md:gap-1" data-id="element-275" data-mp="20cc2n3q6iqgk">
                <span className="text-xs font-bold uppercase tracking-wider text-brand-600" data-id="element-276" data-mp="334uihy1ssjva">Volume</span>
                <span className="font-serif text-5xl md:text-6xl font-extrabold leading-none text-brand-800" data-id="element-277" data-mp="37x4dhshrsa4f">{v.number}</span>
              </div>
              <div data-id="element-278" data-mp="2y6j9fpjbude4">
                <h3 className="font-serif text-2xl sm:text-[28px] font-bold leading-tight text-ink" data-id="element-279" data-mp="2y61fx0o1ud9w">{v.title}</h3>
                <p className="mt-2 text-[17px] font-semibold leading-snug text-brand-700" data-id="element-280" data-mp="3lx6ttaafivhk">{v.tagline}</p>
                <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-281" data-mp="3qu5k1hqz2iah">{v.description}</p>
                <ul className="mt-5 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-282" data-mp="3cue2x855sls9">
                  {v.points.map(pt => <li key={pt} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-283" data-mp="3hsz4baw5dbia">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-284" data-mp="21fh7ngidt0cg">
                        <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-285" data-mp="26d0o8n2jxp7k" />
                      </span>
                      {pt}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-286" data-mp="27irgyvqmxsu">
          <CtaButton label="I want all 6 volumes" data-id="element-287" data-mp="3ud4ev9xmei92" />
        </div>
      </div>
    </section>;
}